import store from "../store/index";
//------------------
// get option image
//------------------
export default function getOptionImage(this_option) {
  //-----------------
  // get all options
  //-----------------
  const this_store = store;
  const options = this_store.getters["combat/getOptions"];
  //-------------------------
  // get matching option obj
  //-------------------------
  let obj = options.find((a) => a.name == this_option);
  if (obj) {
    return obj.image;
  } else {
    alert("Option not found = " + this_option)
  } 
}